import React from 'react';
import { useTexture } from '@react-three/drei';

function Ground() {

  return (
    <>
      {/* Ground */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, -28.5, 0]} receiveShadow>
        <planeGeometry args={[10000, 10000]} />
        <meshStandardMaterial color="#3f3f3f" />
      </mesh>
    </>
  );
}

export default Ground;
